import i18next from "i18next";
import subscription from "@insightfulscience/shared-utils/Emitter/subscriptions";
import format from "../i18-formats/en";

const translator = ({ parent, resources, ...options }) => {
	const { subscribe, notify } = subscription();
	const i18 = i18next.createInstance();

	i18.init({
		whitelist: ["en", "de"],
		ns: ["common"],
		defaultNS: "common",
		fallbackLng: "en",
		fallbackNS: ["common"],
		interpolation: {
			escapeValue: false,
			format,
		},
		returnObjects: true,
		resources,
		partialBundledLanguages: true,
		overloadTranslationOptionHandler: ([, opts]) => ({ value: opts }),
		...options,
		language: options.lng || "en",
		lng: options.lng || "en",
	});

	const handleUpdates = () => notify(i18.language, i18);

	i18.on("languageChanged", handleUpdates);

	const setLanguage = lang => {
		if (lang !== i18.language) {
			i18.changeLanguage(lang);
		}
		if (parent != null && typeof parent.changeLanguage === "function") {
			parent.changeLanguage(lang);
		}
	};

	if (parent != null && typeof parent.on === "function") {
		parent.on("languageChange", setLanguage);
		setLanguage(parent.language);
	}

	const release = () => {
		if (parent != null && typeof parent.off === "function") {
			parent.off("languageChange", setLanguage);
		}
	};

	return { setLanguage, i18, subscribe, release };
};

export default translator;
